import { Button, Popconfirm, Popover, Select, Space } from 'antd';
import { DetailKey } from 'procura-shared';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DetailInput } from './DetailInput';

type DetailsAddButtonProps = {
  label: string;
  placeholder?: string;
  detailKeys?: DetailKey[];
  selectPlaceholder?: string;
  onConfirm?: (value: any | { key: string; value: any }) => void;
};

export const DetailsAddButton = ({
  label,
  placeholder = '',
  selectPlaceholder: optionsPlaceholder = '',
  detailKeys = [],
  onConfirm,
}: DetailsAddButtonProps) => {
  const { t } = useTranslation();
  const getOptions = (): { label: string; value: string }[] => detailKeys.map((value) => ({ label: t(value), value }));

  const [selectedDetailKey, setSelectedDetailKey] = useState<DetailKey>(undefined);
  const [value, setValue] = useState<string | number>(undefined);
  const [visible, setVisible] = useState<boolean>(false);

  const isSelect = (): boolean => detailKeys.length > 0;

  const selectedHandler = (value: DetailKey) => setSelectedDetailKey(value);
  const inputChangeHandler = (e: string | number) => setValue(e);

  const confirmHandler = () => {
    if (isSelect()) onConfirm?.({ key: selectedDetailKey, value: value });
    else onConfirm?.(value);
    reset();
  };

  const reset = () => {
    setSelectedDetailKey(undefined);
    setValue(undefined);
    setVisible(false);
  };

  return (
    <Popover
      trigger="click"
      visible={visible}
      placement="bottom"
      onVisibleChange={(state) => setVisible(state)}
      content={
        <Space direction="vertical">
          {isSelect() && (
            <Select
              style={{ width: '100%' }}
              options={getOptions()}
              value={selectedDetailKey}
              onChange={selectedHandler}
              placeholder={optionsPlaceholder}
            />
          )}
          <DetailInput
            placeholder={placeholder}
            value={value}
            detailKey={selectedDetailKey}
            onChange={inputChangeHandler}
          />
          <Popconfirm title={t('submitChanges')} onConfirm={confirmHandler} okText={t('yes')} cancelText={t('no')}>
            <Button style={{ width: '100%' }} type="primary">
              {t('submit')}
            </Button>
          </Popconfirm>
          <Button style={{ width: '100%' }} type="default" onClick={() => setVisible(false)}>
            {t('cancel')}
          </Button>
        </Space>
      }>
      <Button type="dashed" onClick={() => setVisible(true)} style={{ width: '100%' }}>
        {label}
      </Button>
    </Popover>
  );
};
